
import Vue, { PropType } from 'vue';
import { Unsubscriber } from '@/core/event-bus';
import Api from '@/core/api';
import { PlayerState } from '@/core/player-state';

interface TimeControlConfig {
    startPosition: number;
}

export default Vue.extend({

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        config: {
            type: Object as PropType<TimeControlConfig>,
            default: () => ({} as TimeControlConfig)
        }
    },
    data() {
        return {
            videoLoaded: false,
            videoDurationSecs: NaN,
            videoElapsedSecs: 0,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        formattedTime(): string {
            const videoElapsedSecs = this.videoElapsedSecs - this.startPosition;
            const videoDurationSecs = this.videoDurationSecs - this.startPosition;

            const elapsedTimeFormatted = formatSeconds(videoElapsedSecs);
            const totalTimeFormatted = formatSeconds(videoDurationSecs);

            return `${elapsedTimeFormatted || '-'} / ${totalTimeFormatted || '-'}`;
        },

        startPosition(): number {
            return this.config?.startPosition ?? 0;
        }
    },

    mounted(): void {
        const { unsubscriber, state } = this.api.onStateChange(
            (partial: Partial<PlayerState>) => {
                this.updateState(partial);
            }
        );

        this.updateState(state);
        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy(): void {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        updateState(state: Partial<PlayerState>) {
            this.videoLoaded = state?.videoLoaded ?? this.videoLoaded;
            this.videoDurationSecs = state?.videoDurationSecs ?? this.videoDurationSecs;
            this.videoElapsedSecs = state?.videoElapsedSecs ?? this.videoElapsedSecs;
        }
    }
});

function formatSeconds(sec: number): string {
    if (!sec || sec < 0) {
        return '00:00';
    }

    sec = Math.round(sec);

    const hours = (Math.floor(sec / 3600)).toString();
    const minutes = (Math.floor(sec / 60) % 60).toString();
    const seconds = (sec % 60).toString();

    if (sec < 3600) {
        return `${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }

    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
}
